import React from "react";
import caseBg from '../../assets/img/case_study.png'

const Banner = () => {
  return (
    <div
      className="relative bg-cover bg-center py-24 px-8 h-full"
      style={{ backgroundImage: `url(${caseBg })` }}
    >
      <div className="flex flex-col md:flex-row items-start justify-between relative">
        {/* Left Content */}
        <div className="w-full md:w-2/3 p-5">
          {/* Logos */}
          <div className="space-y-4">
            <img
              src={require('../../assets/img/lohiaLogo.png')}
              alt="Logo 1"
              className="hidden lg:block my-5 w-52 h-20" 
            />
          </div>

          {/* Headline */}
          <h1 className="text-white mt-8 lg:mt-3 text-3xl lg:text-5xl font-semibold leading-tight">
            How Lohia Group Increased Conversions and Streamlined Customer
            Experience
          </h1>
        </div>
      </div>
    </div>
  );
};

export default Banner;
